(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["instagram-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function setup(root) {
      var videos = (root || document).querySelectorAll('.instagram-grid__video');
      if (!videos.length) return;

      videos.forEach(function (video) {
        video.muted = true;
        if (reduceMotion.matches) video.pause();
      });

      if (reduceMotion.matches || !('IntersectionObserver' in window)) return;

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var playing = entry.target.play();
            if (playing && playing.catch) playing.catch(function () {});
          } else {
            entry.target.pause();
          }
        });
      }, { threshold: 0.25 });

      videos.forEach(function (video) { observer.observe(video); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { setup(); });
    } else {
      setup();
    }

    document.addEventListener('shopify:section:load', function (event) { setup(event.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
